import { Tooltip, UIText2 } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './priceAuction.css';

export const PriceAuction = () => {
  return (
    <div className={styles['actual']}>
      <div className={styles['label']}>
        <UIText2 color="text-secondary-default">Начальная цена, аукцион</UIText2>
      </div>
      <Tooltip
        theme="white"
        placement="bottom"
        title={
          <div className={styles['description']}>
            <UIText2>Объект реализуется через проведение торгов в соответствии с&nbsp;ГК РФ.</UIText2>
            <a
              className={styles['link']}
              href="https://hc.cian.ru/hc/ru/articles/360037867052"
              target="_blank"
              rel="noopener noreferrer"
            >
              Справочная информация
            </a>
          </div>
        }
      >
        <IconFunctionalInformationCircle16 color="icon-main-default" />
      </Tooltip>
    </div>
  );
};

PriceAuction.displayName = 'PriceAuction';
